import fr from "./french.json";

export const translationsForUsersLocale: { [id: string]: string } = ((fr) => {
  let x:{[id:string]:string} = {};
  for (const [key, value] of Object.entries(fr)) {
    x[key] = value.message;
  }
  return x;
})(fr);
